import styled from 'styled-components';
import { layout } from 'src/components/base';
import { Panel } from '@prisjakt/ui/panel';

export const Button = styled.button`
  display: flex;

  cursor: pointer;
  .pj-ui-carousel-video-thumbnail--play-icon svg {
    width: 75px !important;
    height: 75px !important;
  }
  .pj-ui-carousel-video-thumbnail {
    width: inherit;
  }
`;

export const StyledPanel = styled(Panel)`
  margin-top: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing100};
`;
